
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq_45T9T_RMiF16TGQA8RN40bJ_45uAbiaibP_gPW2a_CVtFgMeta } from "/src/pages/faq.vue?macro=true";
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as signup03tdUAgjwSVT1YNGbSBuPMMBCXRQLFIu9qqCZlb7GcIMeta } from "/src/pages/signup.vue?macro=true";
import { default as contact_XjdSYBiCuSFsOBRXQNVwomgFJnK4lsCYpDrSQ7swzwMeta } from "/src/pages/contact.vue?macro=true";
import { default as pricingj0etv4OxJJG_45RONf_U3FY2V1mlza9bSr6Hcj4ZP44PkMeta } from "/src/pages/pricing.vue?macro=true";
import { default as roadmapsfVxV1OS42I4kGT7Qi6uKJl82kOynVLD9zIaKf9dr7wMeta } from "/src/pages/roadmap.vue?macro=true";
import { default as featuresmM_45VInHbiR6d0bQ8_45las5bXNO5VsKiCfznc5cnjddUIMeta } from "/src/pages/features.vue?macro=true";
import { default as licenseshZGN3sRl_K1GmWaO3E2iV_45TwfEG19fPZLORm0lVr_aUMeta } from "/src/pages/licenses.vue?macro=true";
import { default as index0xhipLmCNcVxHw976bWFcXKCbh9T_1kD6MYylxzTez8Meta } from "/src/pages/app/index.vue?macro=true";
import { default as setupT6yw9WqRsKj42_lb5Q0CYPEcTSv8wnJ3QFHtVHl7U84Meta } from "/src/pages/app/setup.vue?macro=true";
import { default as companies3XJkIDGOR_459RuqVor01Rx8_yvd11jq7s3UWeog3rD_QMeta } from "/src/pages/companies.vue?macro=true";
import { default as agb92e6QhvCvtNTVoGotRWYAZOWEoLi_45cz_L3D5dGY36dEMeta } from "/src/pages/legal/agb.vue?macro=true";
import { default as loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta } from "/src/pages/auth/login.vue?macro=true";
import { default as freelancerWPXYo_ZkD03K30VWn6jkJVP7dF58ZA3IZ_eJ6bOvEvYMeta } from "/src/pages/freelancer.vue?macro=true";
import { default as settingsIuQv3sTH0L_2XyLBH_RMbFTqC75gN3zpdKjHoWgdqQAMeta } from "/src/pages/app/settings.vue?macro=true";
import { default as imprintbpj7B5fv4OKJTCfMhq107Zu5PocrWQ6JGJS8i70s_hwMeta } from "/src/pages/legal/imprint.vue?macro=true";
import { default as privacy_p09cCi9N0c7hHodq57kzgpmXByTeCKQMUA8fjaehgQMeta } from "/src/pages/legal/privacy.vue?macro=true";
import { default as timesheetnvaIm1BOVzsWzPYufgMNleeb_45kFhHtdIY_45scNOk5MlcMeta } from "/src/pages/tools/timesheet.vue?macro=true";
import { default as indexr4lyITMU_kvzAUrTPgm8EivpJiPFSWEFIQtYuwDsSV4Meta } from "/src/pages/trustcenter/index.vue?macro=true";
import { default as verify_45email_45token8Q8d1_45i57QVamwABvN_RM_Qd2PZt8FngRYXGLAgYDkUMeta } from "/src/pages/verify-email-token.vue?macro=true";
import { default as verifyemailJybNoNXQiuK0siNM450p2xcg6LrRBuEURPU8oI0Ac1kMeta } from "/src/pages/app/legal/verifyemail.vue?macro=true";
import { default as statisticsZapqOvqVLaiWi0Ss7skW_45K8Gvbq_RBNyF_7W_45luncsMMeta } from "/src/pages/app/project-time/statistics.vue?macro=true";
import { default as changesubscription0C5OWc56HgLYNW9KfbXhF3cYSYH_45JsmrsqOAuwnkgDIMeta } from "/src/pages/app/legal/changesubscription.vue?macro=true";
import { default as _91id_93CUpNeclDtXjCcXkyOsjlk659tXpqzYjGPYLQ4hXUoQ8Meta } from "/src/pages/app/project-time/debtor/[id].vue?macro=true";
import { default as index2uliiRoSN9NWawx9_eA50jJKssdtGiPwu5QDMkP4SD0Meta } from "/src/pages/app/project-time/debtor/index.vue?macro=true";
import { default as _91id_93m8X2b_45XpPF4wBkZ5XWxyVeejOV_45Lyl_45svDRlJpxsmf8Meta } from "/src/pages/app/project-time/timelog/[id].vue?macro=true";
import { default as _91id_93d_D1RFnYRYw_45ZbPbBlhX_452irEkemGYaSPLtNeFRPvcsMeta } from "/src/pages/app/project-time/projects/[id].vue?macro=true";
import { default as indexbDeJK4IJgIOSddcpjUcpdc89bVT8j4V1Iq418omJgcQMeta } from "/src/pages/app/project-time/timelog/index.vue?macro=true";
import { default as index_45MpCKkLsZ9oT1FAzaKQMbDItKApv_45LR5j_45IkE3u9gfYMeta } from "/src/pages/app/project-time/projects/index.vue?macro=true";
import { default as createN8jwOyqXjuPwJP_PJKCwajvKJdG68U451rLAQPVqAbEMeta } from "/src/pages/app/project-time/projects/create.vue?macro=true";
import { default as calenderJFIT15d2ETwHZltpgdz4MdAgavsIOTnCjpnLixwppnsMeta } from "/src/pages/app/project-time/timelog/calender.vue?macro=true";
import { default as why_45timetracking_45is_45importantjUA6ySbuNTrKtU_5jwIFOY9pBM3iqwqEDpXOPzstuE0Meta } from "/src/pages/posts/why-timetracking-is-important.vue?macro=true";
import { default as digitalclock0_45XbDgR8_C4WYNmgeQe4R5xb1SLVHoEAPySw5NNi77wMeta } from "/src/pages/app/project-time/timelog/digitalclock.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faq_45T9T_RMiF16TGQA8RN40bJ_45uAbiaibP_gPW2a_CVtFgMeta || {},
    component: () => import("/src/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta || {},
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signup03tdUAgjwSVT1YNGbSBuPMMBCXRQLFIu9qqCZlb7GcIMeta || {},
    component: () => import("/src/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact_XjdSYBiCuSFsOBRXQNVwomgFJnK4lsCYpDrSQ7swzwMeta || {},
    component: () => import("/src/pages/contact.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingj0etv4OxJJG_45RONf_U3FY2V1mlza9bSr6Hcj4ZP44PkMeta || {},
    component: () => import("/src/pages/pricing.vue")
  },
  {
    name: "roadmap",
    path: "/roadmap",
    meta: roadmapsfVxV1OS42I4kGT7Qi6uKJl82kOynVLD9zIaKf9dr7wMeta || {},
    component: () => import("/src/pages/roadmap.vue")
  },
  {
    name: "features",
    path: "/features",
    meta: featuresmM_45VInHbiR6d0bQ8_45las5bXNO5VsKiCfznc5cnjddUIMeta || {},
    component: () => import("/src/pages/features.vue")
  },
  {
    name: "licenses",
    path: "/licenses",
    meta: licenseshZGN3sRl_K1GmWaO3E2iV_45TwfEG19fPZLORm0lVr_aUMeta || {},
    component: () => import("/src/pages/licenses.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: index0xhipLmCNcVxHw976bWFcXKCbh9T_1kD6MYylxzTez8Meta || {},
    component: () => import("/src/pages/app/index.vue")
  },
  {
    name: "app-setup",
    path: "/app/setup",
    component: () => import("/src/pages/app/setup.vue")
  },
  {
    name: "companies",
    path: "/companies",
    meta: companies3XJkIDGOR_459RuqVor01Rx8_yvd11jq7s3UWeog3rD_QMeta || {},
    component: () => import("/src/pages/companies.vue")
  },
  {
    name: "legal-agb",
    path: "/legal/agb",
    meta: agb92e6QhvCvtNTVoGotRWYAZOWEoLi_45cz_L3D5dGY36dEMeta || {},
    component: () => import("/src/pages/legal/agb.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta || {},
    component: () => import("/src/pages/auth/login.vue")
  },
  {
    name: "freelancer",
    path: "/freelancer",
    meta: freelancerWPXYo_ZkD03K30VWn6jkJVP7dF58ZA3IZ_eJ6bOvEvYMeta || {},
    component: () => import("/src/pages/freelancer.vue")
  },
  {
    name: "app-settings",
    path: "/app/settings",
    meta: settingsIuQv3sTH0L_2XyLBH_RMbFTqC75gN3zpdKjHoWgdqQAMeta || {},
    component: () => import("/src/pages/app/settings.vue")
  },
  {
    name: "legal-imprint",
    path: "/legal/imprint",
    meta: imprintbpj7B5fv4OKJTCfMhq107Zu5PocrWQ6JGJS8i70s_hwMeta || {},
    component: () => import("/src/pages/legal/imprint.vue")
  },
  {
    name: "legal-privacy",
    path: "/legal/privacy",
    meta: privacy_p09cCi9N0c7hHodq57kzgpmXByTeCKQMUA8fjaehgQMeta || {},
    component: () => import("/src/pages/legal/privacy.vue")
  },
  {
    name: "tools-timesheet",
    path: "/tools/timesheet",
    meta: timesheetnvaIm1BOVzsWzPYufgMNleeb_45kFhHtdIY_45scNOk5MlcMeta || {},
    component: () => import("/src/pages/tools/timesheet.vue")
  },
  {
    name: "trustcenter",
    path: "/trustcenter",
    meta: indexr4lyITMU_kvzAUrTPgm8EivpJiPFSWEFIQtYuwDsSV4Meta || {},
    component: () => import("/src/pages/trustcenter/index.vue")
  },
  {
    name: "verify-email-token",
    path: "/verify-email-token",
    meta: verify_45email_45token8Q8d1_45i57QVamwABvN_RM_Qd2PZt8FngRYXGLAgYDkUMeta || {},
    component: () => import("/src/pages/verify-email-token.vue")
  },
  {
    name: "app-legal-verifyemail",
    path: "/app/legal/verifyemail",
    meta: verifyemailJybNoNXQiuK0siNM450p2xcg6LrRBuEURPU8oI0Ac1kMeta || {},
    component: () => import("/src/pages/app/legal/verifyemail.vue")
  },
  {
    name: "app-project-time-statistics",
    path: "/app/project-time/statistics",
    meta: statisticsZapqOvqVLaiWi0Ss7skW_45K8Gvbq_RBNyF_7W_45luncsMMeta || {},
    component: () => import("/src/pages/app/project-time/statistics.vue")
  },
  {
    name: "app-legal-changesubscription",
    path: "/app/legal/changesubscription",
    meta: changesubscription0C5OWc56HgLYNW9KfbXhF3cYSYH_45JsmrsqOAuwnkgDIMeta || {},
    component: () => import("/src/pages/app/legal/changesubscription.vue")
  },
  {
    name: "app-project-time-debtor-id",
    path: "/app/project-time/debtor/:id()",
    meta: _91id_93CUpNeclDtXjCcXkyOsjlk659tXpqzYjGPYLQ4hXUoQ8Meta || {},
    component: () => import("/src/pages/app/project-time/debtor/[id].vue")
  },
  {
    name: "app-project-time-debtor",
    path: "/app/project-time/debtor",
    meta: index2uliiRoSN9NWawx9_eA50jJKssdtGiPwu5QDMkP4SD0Meta || {},
    component: () => import("/src/pages/app/project-time/debtor/index.vue")
  },
  {
    name: "app-project-time-timelog-id",
    path: "/app/project-time/timelog/:id()",
    meta: _91id_93m8X2b_45XpPF4wBkZ5XWxyVeejOV_45Lyl_45svDRlJpxsmf8Meta || {},
    component: () => import("/src/pages/app/project-time/timelog/[id].vue")
  },
  {
    name: "app-project-time-projects-id",
    path: "/app/project-time/projects/:id()",
    meta: _91id_93d_D1RFnYRYw_45ZbPbBlhX_452irEkemGYaSPLtNeFRPvcsMeta || {},
    component: () => import("/src/pages/app/project-time/projects/[id].vue")
  },
  {
    name: "app-project-time-timelog",
    path: "/app/project-time/timelog",
    meta: indexbDeJK4IJgIOSddcpjUcpdc89bVT8j4V1Iq418omJgcQMeta || {},
    component: () => import("/src/pages/app/project-time/timelog/index.vue")
  },
  {
    name: "app-project-time-projects",
    path: "/app/project-time/projects",
    meta: index_45MpCKkLsZ9oT1FAzaKQMbDItKApv_45LR5j_45IkE3u9gfYMeta || {},
    component: () => import("/src/pages/app/project-time/projects/index.vue")
  },
  {
    name: "app-project-time-projects-create",
    path: "/app/project-time/projects/create",
    meta: createN8jwOyqXjuPwJP_PJKCwajvKJdG68U451rLAQPVqAbEMeta || {},
    component: () => import("/src/pages/app/project-time/projects/create.vue")
  },
  {
    name: "app-project-time-timelog-calender",
    path: "/app/project-time/timelog/calender",
    meta: calenderJFIT15d2ETwHZltpgdz4MdAgavsIOTnCjpnLixwppnsMeta || {},
    component: () => import("/src/pages/app/project-time/timelog/calender.vue")
  },
  {
    name: "posts-why-timetracking-is-important",
    path: "/posts/why-timetracking-is-important",
    meta: why_45timetracking_45is_45importantjUA6ySbuNTrKtU_5jwIFOY9pBM3iqwqEDpXOPzstuE0Meta || {},
    component: () => import("/src/pages/posts/why-timetracking-is-important.vue")
  },
  {
    name: "app-project-time-timelog-digitalclock",
    path: "/app/project-time/timelog/digitalclock",
    meta: digitalclock0_45XbDgR8_C4WYNmgeQe4R5xb1SLVHoEAPySw5NNi77wMeta || {},
    component: () => import("/src/pages/app/project-time/timelog/digitalclock.vue")
  }
]